import { render } from "./ViewParticipantsBoard.vue?vue&type=template&id=6461c5fa"
import script from "./ViewParticipantsBoard.vue?vue&type=script&lang=js"
export * from "./ViewParticipantsBoard.vue?vue&type=script&lang=js"

import "./ViewParticipantsBoard.vue?vue&type=style&index=0&id=6461c5fa&lang=scss"
script.render = render

export default script